import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetTenantSmtpConnectionMutationVariables = Types.Exact<{
  input: Types.SetTenantSmtpConnectionInput;
}>;


export type SetTenantSmtpConnectionMutation = { __typename?: 'Mutation', setTenantSmtpConnection: { __typename?: 'TenantSmtpConnectionPayload', connection?: { __typename?: 'TenantSmtpConnectionData', host: string, port: number, username: string, fromMode: Types.SmtpFromMode, status: Types.SmtpConnectionStatus, lastVerifiedAt?: Types.TDateISO | null, lastError?: string | null, updatedAt: Types.TDateISO, addresses: Array<{ __typename?: 'SmtpSenderAddressData', email: string, displayName: string, adminOnly: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type VerifyTenantSmtpConnectionMutationVariables = Types.Exact<{
  input: Types.VerifyTenantSmtpConnectionInput;
}>;


export type VerifyTenantSmtpConnectionMutation = { __typename?: 'Mutation', verifyTenantSmtpConnection: { __typename?: 'TenantSmtpConnectionPayload', connection?: { __typename?: 'TenantSmtpConnectionData', host: string, port: number, username: string, fromMode: Types.SmtpFromMode, status: Types.SmtpConnectionStatus, lastVerifiedAt?: Types.TDateISO | null, lastError?: string | null, updatedAt: Types.TDateISO, addresses: Array<{ __typename?: 'SmtpSenderAddressData', email: string, displayName: string, adminOnly: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveTenantSmtpConnectionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RemoveTenantSmtpConnectionMutation = { __typename?: 'Mutation', removeTenantSmtpConnection: { __typename?: 'TenantSmtpConnectionPayload', connection?: { __typename?: 'TenantSmtpConnectionData', host: string, port: number, username: string, fromMode: Types.SmtpFromMode, status: Types.SmtpConnectionStatus, lastVerifiedAt?: Types.TDateISO | null, lastError?: string | null, updatedAt: Types.TDateISO, addresses: Array<{ __typename?: 'SmtpSenderAddressData', email: string, displayName: string, adminOnly: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetTenantSmtpConnectionDocument = new TypedDocumentString(`
    mutation SetTenantSmtpConnection($input: SetTenantSmtpConnectionInput!) {
  setTenantSmtpConnection(input: $input) {
    connection {
      ...TenantSmtpConnection
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantSmtpConnection on TenantSmtpConnectionData {
  host
  port
  username
  fromMode
  addresses {
    email
    displayName
    adminOnly
  }
  status
  lastVerifiedAt
  lastError
  updatedAt
}`);
export const VerifyTenantSmtpConnectionDocument = new TypedDocumentString(`
    mutation VerifyTenantSmtpConnection($input: VerifyTenantSmtpConnectionInput!) {
  verifyTenantSmtpConnection(input: $input) {
    connection {
      ...TenantSmtpConnection
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantSmtpConnection on TenantSmtpConnectionData {
  host
  port
  username
  fromMode
  addresses {
    email
    displayName
    adminOnly
  }
  status
  lastVerifiedAt
  lastError
  updatedAt
}`);
export const RemoveTenantSmtpConnectionDocument = new TypedDocumentString(`
    mutation RemoveTenantSmtpConnection {
  removeTenantSmtpConnection {
    connection {
      ...TenantSmtpConnection
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantSmtpConnection on TenantSmtpConnectionData {
  host
  port
  username
  fromMode
  addresses {
    email
    displayName
    adminOnly
  }
  status
  lastVerifiedAt
  lastError
  updatedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetTenantSmtpConnection: build.mutation<SetTenantSmtpConnectionMutation, SetTenantSmtpConnectionMutationVariables>({
      query: (variables) => ({ document: SetTenantSmtpConnectionDocument, variables })
    }),
    VerifyTenantSmtpConnection: build.mutation<VerifyTenantSmtpConnectionMutation, VerifyTenantSmtpConnectionMutationVariables>({
      query: (variables) => ({ document: VerifyTenantSmtpConnectionDocument, variables })
    }),
    RemoveTenantSmtpConnection: build.mutation<RemoveTenantSmtpConnectionMutation, RemoveTenantSmtpConnectionMutationVariables | void>({
      query: (variables) => ({ document: RemoveTenantSmtpConnectionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetTenantSmtpConnectionMutation, useVerifyTenantSmtpConnectionMutation, useRemoveTenantSmtpConnectionMutation } = injectedRtkApi;
